module.exports = __webpack_public_path__ + "img/train-9.7cecbb2a.jpg";